<script setup>
import { create_faq } from '@/services/faqs';
import { get_terms } from '@/services/terms';
import { onMounted, ref } from 'vue';

const faq = ref({
  title: '',
  description: '',
  category: ''
})

const categoryOption = ref([])

onMounted(async ()=>{
  await get_category()
})

async function get_category(){
  let response = await get_terms('faq_category')
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return 
  }
  categoryOption.value = parseOptions(response.result.data.data)
}

function parseOptions(cats){
  cats = cats.map(item => {
    return {
      valueProp: item.relationships.term_taxonomy.data.id,
      label: item.attributes.name,
      disabled: false  
    }
  })
  return cats
}

const isSubmitting = ref(false)
async function submit_form(){
  isSubmitting.value = true
  let params = {
    faq_obj:{
      title: faq.value.title,
      description: faq.value.description
    },
    term_relationship:{
      term_taxonomy_id: faq.value.category
    }
  }
  let response = await create_faq(params)
  isSubmitting.value = false
  if (response.error){
    Swal.fire({
      title: 'Error',
      text: response.result.error,
      icon: 'error'
    })
    return
  }
  Swal.fire({
    title: 'Added',
    text: 'Faq has been created',
    icon: 'success'
  })
  faq.value = {
    title: '',
    description: '',
    category: ''
  }
}
</script>

<template>
  <Breadcrumbs main="New FAQ"/>
  
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <input type="text" 
              name="title" 
              id="title" 
              class="form-control" 
              v-model="faq.title"
              placeholder="FAQ Title"
            >
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <textarea class="form-control" name="description" id="description" cols="30" rows="10" 
              v-model="faq.description"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <multiselect 
              v-model="faq.category" 
              placeholder="Select category"
              :options="categoryOption"
              valueProp="valueProp"
              searchable="true"
            ></multiselect>
            <button :disabled="isSubmitting" class="mt-2 btn btn-light-success" @click="submit_form()">
              <div v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <template v-else>
                Create FAQ
              </template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>